$(document).ready(function () {
    //PASSWORD SHOW/HIDE
    var passwordInputs = $("input[type=password]");

    passwordInputs.each(function () {
        var passwordInput = $(this);
        var passwordParent = passwordInput.closest("div");

        // Determine size class
        var sizeClass = "";
        if (passwordInput.hasClass("form-control-lg")) {
            sizeClass = "btn-lg";
        } else if (passwordInput.hasClass("form-control-sm")) {
            sizeClass = "btn-sm";
        }

        // Apply padding and position
        passwordInput.css("padding-right", "40px");
        passwordParent.css("position", "relative")
            .append('<a href="#" tabindex="-1" class="btn js-show-pass ' + sizeClass + '"><i class="bi bi-eye-fill"></i></a>');

        var showPassButton = passwordParent.find(".js-show-pass").last();
        var inputHeight = passwordInput.outerHeight();

        showPassButton.css({
            "height": inputHeight + "px",
        });
    });

    $(document).on("click", ".js-show-pass", function (e){
        e.preventDefault();
        var input = $(this).siblings("input");
        var icon = $(this).find("i");
        if(input.attr('type') === 'password'){
            input.attr('type','text')
            icon.removeClass("bi-eye-fill").addClass("bi-eye-slash-fill");
        }else{
            input.attr('type','password');
            icon.removeClass("bi-eye-slash-fill").addClass("bi-eye-fill");
        }
    })
})
